import HeaderText from "@/components/header/HeaderText";
import HeaderWrapper from "@/components/header/HeaderWrapper";
import { useTranslations } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/TranslationContext";

export default function ConversationsHeader({ messengerId }: { messengerId: string }) {
  const t = useTranslations();
  return (
    <HeaderWrapper
      padded
      leftSlot={<HeaderText>{t("Nav.messages")}</HeaderText>}
      messengerId={messengerId}
      closeButtonNudgeRight
    />
  );
}
